import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { OnboardingService } from '../services/onboarding.service';

/**
 * Guard que redirige al onboarding si el usuario no lo ha completado
 */
export const onboardingGuard: CanActivateFn = () => {
  const onboardingService = inject(OnboardingService);
  const router = inject(Router);

  if (!onboardingService.isOnboardingCompleted()) {
    return router.createUrlTree(['/onboarding']);
  }

  return true;
};

/**
 * Guard que previene el acceso al onboarding si ya fue completado
 */
export const onboardingCompletedGuard: CanActivateFn = (route) => {
  if(route.queryParamMap.get('review')==='1')return true;
  const onboardingService = inject(OnboardingService);
  const router = inject(Router);

  if (onboardingService.isOnboardingCompleted()) {
    return router.createUrlTree(['/home']);
  }

  return true;
};
